// import braintree from "braintree-web";

import { PaypalStrategy } from "./braintree/paypal";
import { CreditCardStrategy } from "./braintree/hostedfields";
import { GooglePayStrategy } from "./braintree/googlepay";
import { LocalpayStrategy } from "./braintree/ideal";
import { ApplePayStrategy } from "./braintree/applePay";

export interface PaymentStrategy {
  initializePayment(
      client,
      data_collector,trolleyDetail
  ): Promise<any>;
  processPayment(): Promise<any>;
  // createTransiction(): any;
  verify3Ds?(): any;
  teardown(): any;
}

class PaymentContext {
  private strategy: PaymentStrategy;
  private data_collector
  private client
  private strategies: any;

  constructor(strategy: PaymentStrategy) {
    this.strategy = strategy;
  }

  setStrategy(strategy: PaymentStrategy) {
    this.strategy = strategy;
  }

  async loadBraintreeScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
  }

  async initializePayment(clientToken: string,trolleyDetail = null): Promise<void> {
    let errorTitle;
    let error;
    let errorMeta;
    try {

      if (!(window as any).braintree || !(window as any).braintree.dataCollector) {
        await this.loadBraintreeScript('https://js.braintreegateway.com/web/3.120.2/js/client.min.js');
        await this.loadBraintreeScript('https://js.braintreegateway.com/web/3.120.2/js/data-collector.min.js');
      }

      const braintree = (window as any).braintree;

      this.client = await braintree.client.create({
        authorization: clientToken,
      });

      if(!braintree.dataCollector){
        errorTitle = "Braintree dataCollector not found";
        error = new Error(errorTitle);
        errorMeta = {
          clientToken: clientToken,
          braintree: braintree,
          braintreeError: true
        }
        const { $customClientErrorHandler } = useNuxtApp();
        $customClientErrorHandler(
            error,
            'high',
            errorTitle,
            errorMeta
        )

        throw error;
      }
      this.data_collector = await  braintree.dataCollector.create({
        client: this.client,
      });


      useCheckoutStore().device_data = this.data_collector.deviceData;

      await this.strategy.initializePayment(this.client, this.data_collector,trolleyDetail);
    } catch (error) {
      console.error('Error initializing payment:', error);
      throw error;
    }
  }

  async processPayment() {
    return await this.strategy.processPayment();
  }

  async verify3Ds() {
    return await this.strategy.verify3Ds();
  }

  teardown() {
    this.strategy.teardown();
  }
}

export class PaymentService {
  private client_token: any;
  private paymentContext: PaymentContext;

  constructor() {
    this.braintreeClient = null;
    this.paymentContext = new PaymentContext(); //default
  }

  async initializeBraintree(clientToken: string) {
    this.client_token = clientToken;
  }

  setPaymentMethod(method: string): void {
    switch (method) {
      case "credit_card":
        this.paymentContext.setStrategy(new CreditCardStrategy());
        break;
      case "paypal":
        this.paymentContext.setStrategy(new PaypalStrategy());
        break;
      case "google_pay":
        this.paymentContext.setStrategy(new GooglePayStrategy());
        break;
      case "local_pay":
        this.paymentContext.setStrategy(new LocalpayStrategy());
        break;
      case "apple_pay":
        this.paymentContext.setStrategy(new ApplePayStrategy());
        break;
    }
  }

  async initializePayment(trolleyDetail = null) {
    await this.paymentContext.initializePayment(this.client_token,trolleyDetail);
  }

  async processPayment() {
    await this.paymentContext.processPayment();
  }


  teardown() {
    this.paymentContext.teardown();
  }
}
